export default __webpack_public_path__ + "static/media/clicksims.0223462f.png";